import { Box, Button, Collapse, useTheme } from "@mui/material";

import React from "react";
import { useSelector } from "react-redux";
import { searchFormSelector } from "redux/searchForm";
import { useTranslations } from "hooks/useTranslations";
import { pushToDataLayer } from "@thekilroygroup/shared-ui";

interface IProps {
  handleSubmit: (e: React.MouseEvent) => void;
  disabled?: boolean;
}

export default function SearchButton(props: IProps) {
  const { disabled, handleSubmit = (e: React.MouseEvent) => {} } = props;
  const searchForm = useSelector(searchFormSelector);

  const {
    translations: {
      search: {
        button: { label },
      },
    },
  } = useTranslations();
  const { transitions } = useTheme();
  const onSubmit = (e: React.MouseEvent) => {
    pushToDataLayer("Click search button", "Search flights");
    handleSubmit(e);
  };
  return (
    <>
      <Collapse
        in={searchForm.tripType === "MULTI_DEST"}
        easing={transitions.easing.easeIn}
        timeout={transitions.duration.shortest}
      >
        <Box sx={{ height: { md: 27, xl: 33.5 } }} />
      </Collapse>
      <Button
        color="primary"
        size="xLarge"
        variant="contained"
        onClick={onSubmit}
        disabled={disabled}
        sx={{
          width: 1,
          px: 0,
        }}
      >
        {label}
      </Button>
    </>
  );
}
